import { merge } from 'lodash'
import { remFactory } from './helper/unit'
import { createColorPalette } from './helper/colors'

const DefaultStyles = {
  baseSize: 14,
  breakpoints: [40, 52, 64].map(n => `${n}em`),
  useRem: false,
  stateColor: {
    disable: 'lightmore',
    hover: 'dark',
    active: 'darker',
  },
}

export default function createStyles(conf) {
  const styleConf = merge({}, DefaultStyles, conf)

  const baseSize = styleConf.baseSize
  const useRem = styleConf.useRem
  const { getLength } = remFactory(useRem, baseSize)

  const palette = createColorPalette(styleConf.palette)

  Object.keys(palette)
    .forEach(k => {
      Object.keys(styleConf.stateColor)
        .forEach(s => {
          const mapValue = styleConf.stateColor[s]
          palette[k][s] = palette[k][mapValue]
        })
    })

  const colors = {}

  Object.keys(styleConf.colors)
    .forEach(color => {
      palette[color] = palette[styleConf.colors[color]]
      colors[color] = palette[color].base
    })
  colors.palette = palette

  const sizes = merge({
  }, styleConf.size || {})

  const space = merge({}, styleConf.space || {})

  const fonts = merge({}, styleConf.fonts || {})
  const fontSizes = merge({}, styleConf.fontSizes || {})
  const lineHeights = merge({}, styleConf.lineHeights || {})
  const shadows = merge({}, styleConf.shadows)
  const radii = merge({}, styleConf.radii || {})
  const borderWidths = merge({}, styleConf.borderWidths || {})

  const fontWeights = merge({
    regular: 400,
  }, styleConf.fontWeights || {})

  const borderStyles = merge({
    outline: 'solid',
  }, styleConf.borderStyles)

  const borders = Object.keys(borderWidths)
    .reduce((acc, widthName) => {
      (styleConf.borderColors || []).forEach(colorName => {
        acc[`${colorName}${widthName}`] = `${
          borderWidths[widthName]
        }px solid ${colors[colorName]}`
      })
      return acc
    }, {})

  return {
    conf: styleConf,
    breakpoints: styleConf.breakpoints,

    // width & height
    sizes,

    // margin
    space,

    // Colors
    colors,

    // FIXME: fills,

    // Typography
    fonts,
    fontSizes,
    lineHeights,
    fontWeights,

    // shadows
    shadows,

    // borders
    radii,
    borderWidths,
    borderStyles,
    borders,

    // Helpers
    base: {
      getLength,
    },

    name: `${conf.name}@${conf.version}`,
  }
}
